import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus, UserCheck, Ban } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export function SellerActions({ sellerId }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [rel, setRel] = useState(null);

  useEffect(() => {
    if (!user || !sellerId) { setRel(null); return; }
    api.get(`/sellers/${sellerId}/relationship`).then((r) => setRel(r.data)).catch(() => {});
  }, [user, sellerId]);

  if (!user || !rel || rel.is_self) return null;

  const toggleFollow = async () => {
    try {
      if (rel.following) {
        await api.delete(`/sellers/${sellerId}/follow`);
        toast.success("Unfollowed seller");
      } else {
        await api.post(`/sellers/${sellerId}/follow`);
        toast.success("Following, you'll see their new ads");
      }
      setRel((r) => ({ ...r, following: !r.following }));
    } catch { toast.error("Could not update. Please try again."); }
  };

  const blockSeller = async () => {
    if (!window.confirm("Block this seller? Their ads will be hidden, you'll stop following them, and you won't be able to message each other.")) return;
    try {
      await api.post(`/users/${sellerId}/block`);
      toast.success("Seller blocked, their ads are now hidden");
      navigate("/");
    } catch { toast.error("Could not block. Please try again."); }
  };

  return (
    <div className="flex gap-2 mt-4" data-testid="seller-actions">
      <Button size="sm" variant="outline" data-testid="follow-seller" onClick={toggleFollow}
        className={`flex-1 ${rel.following ? "border-emerald-500 bg-emerald-50 text-emerald-700" : ""}`}>
        {rel.following ? <><UserCheck size={15} className="mr-1" /> Following</> : <><UserPlus size={15} className="mr-1" /> Follow</>}
      </Button>
      <Button size="sm" variant="outline" data-testid="block-seller" onClick={blockSeller} className="text-red-600 border-red-200">
        <Ban size={15} className="mr-1" /> Block
      </Button>
    </div>
  );
}
